import { __rest, __assign } from '../../../../node_modules/tslib/tslib.es6.js';
import React from 'react';
import { TableHeaderStyled } from './style.js';
import { TableContextContextConsumer } from './TableContext.js';

var TableHeader = function TableHeader(_a) {
  var _b = _a.showBottomBorder,
      showBottomBorder = _b === void 0 ? true : _b,
      children = _a.children,
      rest = __rest(_a, ["showBottomBorder", "children"]);

  return /*#__PURE__*/React.createElement(TableContextContextConsumer, null, function (tableContext) {
    return tableContext && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TableHeaderStyled, __assign({
      theme: tableContext.theme,
      showBottomBorder: showBottomBorder,
      padding: tableContext.padding,
      freezeFirstColumn: tableContext.freezeFirstColumn,
      frozenColumnWidth: tableContext.frozenColumnWidth
    }, rest), children));
  });
};

export default TableHeader;
export { TableHeader };